import * as React from 'react';
import { CategoriesCarouselWidget, getWebSolutionData, extractTagsDefinition, } from '@wix/app-market-collection-widget';
import s from './style.scss';
import { config } from '../../../../config';
import { Path } from '../../../..';
import { getTagBiData } from '../../biData';
import { composer } from '../../../../component-decorators/composer';
import { biLogger } from '../../../../bi';
import { Heading } from 'wix-style-react';
import { addUrl } from '../../../../common/addUrl';
import { shouldRenderAsLink } from '../../../../common/utils';
import { useConfigContext } from '../../../../config-context';
export var categoriesCarouselSectionDTOtoProps = function (sectionDTO) {
    var _a;
    var tagData = sectionDTO.tagData;
    var tagsToWebSolutions = tagData.tagsToWebSolutions;
    var webSolutions = (_a = tagsToWebSolutions === null || tagsToWebSolutions === void 0 ? void 0 : tagsToWebSolutions.webSolutions) === null || _a === void 0 ? void 0 : _a.webSolutions;
    var innerTagsDefinitions = extractTagsDefinition(tagsToWebSolutions) || [];
    var webSolutionsData = (webSolutions &&
        webSolutions.map(function (solution) {
            return getWebSolutionData(solution);
        })) ||
        [];
    return {
        displayName: tagData.displayName,
        webSolutions: webSolutionsData,
        innerTagsDefinitions: innerTagsDefinitions,
    };
};
export var CategoriesCarousel = composer()
    .withMarketplaceStore()
    .compose(function (_a) {
    var displayName = _a.displayName, innerTagsDefinitions = _a.innerTagsDefinitions, marketplaceStore = _a.marketplaceStore, _b = _a.className, className = _b === void 0 ? '' : _b;
    var biData = getTagBiData(innerTagsDefinitions, 'explore_by_category', 'category', 'categories_carousel', marketplaceStore.metaSiteId, marketplaceStore.route, marketplaceStore.prevRoute);
    return (React.createElement("div", { "data-testid": 'categories-carousel', className: s.wrapper + " " + className },
        React.createElement("div", { className: s.contentWrapper },
            React.createElement(Heading, { appearance: "H2", dataHook: "widget-title", className: s.widgetTitle }, displayName),
            React.createElement(CategoriesCarouselWrapper, { innerTagsDefinitions: innerTagsDefinitions, metaSiteId: marketplaceStore.metaSiteId, biData: biData }))));
});
var CategoriesCarouselWrapper = function (_a) {
    var innerTagsDefinitions = _a.innerTagsDefinitions, metaSiteId = _a.metaSiteId, biData = _a.biData;
    var _b = useConfigContext(), locale = _b.locale, i18n = _b.i18n, baseUrl = _b.baseUrl;
    return (React.createElement("span", { className: s.categoriesCarouselWrapper },
        React.createElement(CategoriesCarouselWidget, { i18n: i18n, as: shouldRenderAsLink(), categories: addUrl(baseUrl, innerTagsDefinitions, function (c) { return "" + baseUrl + Path.CATEGORY + "/" + c.slug; }), onCategoryClickHandler: function (category) {
                // tslint:disable-next-line: no-floating-promises
                biLogger.categoryClick({
                    category: category.slug.replace(/-/g, '_'),
                    msid: metaSiteId,
                    origin: 'categories_carousel',
                    tag_name: category.slug.replace(/-/g, '_'),
                    tag_type: 'category',
                });
                config.goto({ path: Path.CATEGORY, slug: category.slug });
            }, biData: biData, locale: locale })));
};
//# sourceMappingURL=index.js.map